import { render, staticRenderFns } from "./GalleryPrimary.vue?vue&type=template&id=804b9c48&"
import script from "./GalleryPrimary.vue?vue&type=script&lang=js&"
export * from "./GalleryPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports